import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "box scrollBox" }
const _hoisted_2 = { class: "float-right" }
const _hoisted_3 = { class: "boxTitle mb-3" }
const _hoisted_4 = { class: "dashboardCalendar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      width: "80",
      filter: "data",
      sort: "data",
      filterType: "date"
    }, "Data"),
    /*#__PURE__*/_createElementVNode("td", {
      width: "100",
      filter: "cliente.name",
      sort: "cliente.name"
    }, "Cliente"),
    /*#__PURE__*/_createElementVNode("td", { filter: "fasciaOraria" }, "Fascia oraria"),
    /*#__PURE__*/_createElementVNode("td", {
      filter: "note",
      sort: "note"
    }, "Note"),
    /*#__PURE__*/_createElementVNode("td", {
      filter: "stato.value",
      sort: "stato.value"
    }, "Stato"),
    /*#__PURE__*/_createElementVNode("td")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { colspan: "99" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModalOrari && _ctx.openModalOrari(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Apri gestione orari",
          text: "Apri gestione orari"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        localizedKey: "I tuoi appuntamenti",
        text: "I tuoi appuntamenti"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_op_table, {
        class: "table table-striped",
        items: _ctx.aptNutrizionista,
        filtersFn: _ctx.filtersFn
      }, {
        default: _withCtx((opData) => [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (opData.items.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Nessun elemento trovato",
                      text: "Nessun elemento trovato"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.data)), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: '#/clienti/detail/' + item.cliente.identifier
                  }, _toDisplayString(item.cliente.name), 9, _hoisted_8)
                ]),
                _createElementVNode("td", null, "Dalle " + _toDisplayString(_ctx.$filters.timespan(item.fasciaOraria.from)) + " alle " + _toDisplayString(_ctx.$filters.timespan(item.fasciaOraria.to)), 1),
                _createElementVNode("td", null, _toDisplayString(item.note), 1),
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(item.stato.value), 1),
                  _hoisted_9,
                  _createTextVNode("(" + _toDisplayString(_ctx.$filters.date(item.stato.date, "YYYY-MM-DD HH:mm")) + ")", 1)
                ]),
                _createElementVNode("td", null, [
                  (item.stato.value != 'Concluso' && item.stato.value != 'Annullato' && item.stato.value != 'Respinto')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.$store.state.isAdmin() || _ctx.$store.state.user.identifier == item.nutrizionista.identifier)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-success",
                              onClick: ($event: any) => (_ctx.concludiPrenotazione(item.identifier))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Concludi",
                                text: "Concludi"
                              })
                            ], 8, _hoisted_10))
                          : _createCommentVNode("", true),
                        (_ctx.$store.state.isAdmin() || _ctx.$store.state.user.identifier == item.nutrizionista.identifier)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-primary ml-2",
                              onClick: ($event: any) => (_ctx.respingiPrenotazione(item.identifier))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Respingi",
                                text: "Respingi"
                              })
                            ], 8, _hoisted_11))
                          : _createCommentVNode("", true),
                        (_ctx.$store.state.isAdmin() || _ctx.$store.state.user.identifier == item.nutrizionista.identifier)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "btn btn-warning ml-2",
                              onClick: ($event: any) => (_ctx.spostaPrenotazione(item.identifier))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Sposta",
                                text: "Sposta"
                              })
                            ], 8, _hoisted_12))
                          : _createCommentVNode("", true),
                        (_ctx.$store.state.isAdmin() || _ctx.$store.state.user.identifier == item.nutrizionista.identifier)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              type: "button",
                              class: "btn btn-danger ml-2",
                              onClick: ($event: any) => (_ctx.deletePrenotazione(item.identifier))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Annulla",
                                text: "Annulla"
                              })
                            ], 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["items", "filtersFn"])
    ])
  ]))
}